<template lang="pug">
v-list.py-0( dense, :color="!ticket.abierto ? 'secondary' : ''" )
  v-divider(inset)
  v-list-item(:key='ticket.title', @click="handlerClick(ticket.numero)")
    v-avatar.mr-4(color='secondary', size="30", v-if="perfilUsuario !== 'usuario-contrato' && perfilUsuario !== 'usuario' && !isChart")
      avatar-perfil(:is-fetch="true",  :usuario="ticket.usuario")
    v-list-item-content.py-2
      .d-flex
        .d-flex.fd-column
          .d-flex.ai-center
            v-chip.mr-1(:color="ticket.numeroInformeTecnico && perfilUsuario !== 'usuario-contrato' && perfilUsuario !== 'usuario' ? 'success-chip' : 'secondary primary--text'"  small label)
              span.font-weight-700.font-size-11 {{ticket.numero}}
            v-chip.mx-1(color="secondary primary--text"  small label v-if="showNumeroInforme")
              span.font-weight-700.font-size-11 IT: {{ticket.numeroInformeTecnico}}
            .d-flex.fd-column.text-left
              span(v-if="perfilUsuario === 'dispatcher'")
                strong.font-size-12(v-if="ticket.tipoticket === 'contrato'") {{ticket.codigoClienteSap}}&nbsp;
                //-strong.font-size-12(v-if="ticket.tipoticket !== 'contrato' && ticket.codigoClienteSap") {{ticket.codigoClienteSap}} -&nbsp;
              span.font-size-12.font-weight-700 {{ticket.razonSocial}}
              span.font-size-10.text-muted {{ticket.usuario}}
        v-spacer
        //- .d-flex.fd-column(v-if="!isMovil && !isChart")
        //-   estados-ticket(:tipo="ticket.tipoticket", :codigo="ticket.estado" :etapa="ticket.etapaEstado", small, read-only)
      .d-flex.fd-column
        .d-flex(v-if="ticket.serie || ticket.modelo")
          v-icon.mr-1(size="14") home_repair_service
          small.font-size-10.text-muted Serie registrada&nbsp;
            small.font-size-10.font-weight-700.grey--text  {{ticket.serie}}&nbsp;
          small.font-size-10.text-muted(v-if="ticket.modelo") con modelo&nbsp;
            small.font-size-10.font-weight-700.grey--text  {{ticket.modelo}}
        .d-flex(v-if="ticket.recall && !isChart")
          v-icon.mr-1(size="14" color="primary") repeat
          small.font-size-10.text-muted.primary--text.font-weight-700 Cuenta con {{ticket.recall}} recall
        .d-flex(v-if="+ticket.serieRepetida === 1 && !ticket.recall")
          v-icon.mr-1(size="14" color="primary") repeat
          small.font-size-10.text-muted.primary--text.font-weight-700 Cuenta con mas de 1 ticket
        .d-flex(:class="{'fd-column' : isMovil, 'ai-center' : !isMovil}")
          small.font-size-10.font-weight-700(:class="usuarioLogeado !== ticket.usuarioUltimaActividad ? 'info--text' : 'grey--text'")
            v-icon.mr-1(size="14", :color="usuarioLogeado !== ticket.usuarioUltimaActividad ? 'info' : ''", ) visibility_off
            | Ultima actividad {{ticket.fechaUltimaActividad | now}} por {{ticket.nombreUsuarioUltimaActividad}}
          v-spacer
          small.font-size-10.text-muted.font-weight-700(v-if="!isChart")  Creado {{ticket.fechaRegistro | now}}
</template>

<script>
  import { apiPost, notify } from '../util/general'
  import avatarPerfil        from './c_avatar_perfil'
  import moment from 'moment'
  export default {
    name : 'c_item_ticket_lista',
    components : {
      'avatar-perfil' : avatarPerfil
      // 'estados-ticket': estadosTicket
    },
    props: ['ticket', 'isChart', 'handler', 'showNumeroInforme'],
    data () {
      return {
        perfilUsuario : localStorage.getItem('perfil'),
        usuarioLogeado: localStorage.getItem('username')
      }
    },
    filters : {
      now: function (value) {
        if (!value) return ''
        return moment(value).fromNow()
      }
    },
    computed : {
      isMovil () {
        var vm = this
        return vm.$vuetify.breakpoint.smAndDown
      }
    },
    methods: {
      handlerClick (numero) {
        var vm = this
        if (vm.handler) vm.$emit('href')
        else {
          vm.$emit('goTo', `/ticket/${numero}`)
        }
      },
      integrarTicket () {
        var vm = this
        vm.$store.dispatch('transaccion', {isProceso : true, message : `Integrando ticket ${vm.ticket.numero}`})
        var obj = {
          numero: vm.ticket.numero
        }

        apiPost(vm, '/integracion/create', obj, function (data) {
          notify(vm, 'success', 'Éxito', ('Integrado correctamente con el numero ' + data.numeroInformeTecnico))
          vm.ticket.numeroInformeTecnico = data.numeroInformeTecnico
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          vm.$store.dispatch('transaccion', {isProceso : false})
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.border-left
  border-left: 3px solid #ffa229;
.success-chip
  background-color: #00d3701c !important;
  color: #00d370 !important;
  // border 1px solid
</style>



// WEBPACK FOOTER //
// c_item_ticket_lista.vue?4c3944ca